<script>
  import { authModule } from "@/stores/auth.js";
  import { logoutModule } from "@/stores/autoLogout.js";
  import { mapStores } from 'pinia'
  export default {
    name: "login",
    data() {
      return {
        loggingin: false,
        activating: false,
        email: '',
        password: '',
        verifypassword: '',
        stamp: '',
        activate: false,
        isPasswordVisible: false
      }
    },
    computed: {
      ...mapStores(authModule),
      ...mapStores(logoutModule)
    },
    mounted() {
      this.passVisibility()
    },
    beforeUnmount() {
      this.email = ''
      this.password = ''
      this.verifypassword = ''
      this.stamp = ''
    },
    methods: {
      async login() {
        this.loggingin = true
        let { data } = await this.$axios.post('/manager/login', {email: this.email, password: this.password})

        if (data.token) {
          this.loggingin = false
          localStorage.setItem('token', data.token)
          this.authStore.setUser(data.user)
          this.logoutStore.autoLog()
          if (localStorage.getItem('redirect')) {
            this.$router.push(localStorage.getItem('redirect'))
            localStorage.removeItem('redirect')
          } else {
            this.$router.push('/')
          }
        }
        if (data.message) {
          this.loggingin = false
          await this.$swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: data.message,
          })
        }
        if (data.tokenDestroyed === 'no') {
          this.password = ''
          this.activate = true
          this.stamp = data.stamp
        }
      },
      passVisibility() {
        let elements = document.querySelectorAll('.password-toggle');

        for (let i = 0; i < elements.length; i++) {
          let passInput = elements[i].querySelector('.form-control'),
              passToggle = elements[i].querySelector('.password-toggle-btn');

          passToggle.addEventListener('click', (e) => {

            if (e.target.type !== 'checkbox') return;
            if (e.target.checked) {
              passInput.type = 'text';
            } else {
              passInput.type = 'password';
            }

          }, false);
        }
      }
    }
  }
</script>

<template>
  <div class="d-flex justify-content-center align-items-center vh-100">
    <div class="w-auto">
      <div class="text-center">
        <img class="img-fluid mb-4" src="/farin-to-yaad.png" width="150" alt=""/>
      </div>
      <div class="card">
        <div class="card-body">
          <form class="needs-validation" @submit.prevent="login()" novalidate>
            <p class="lead text-center text-muted">Login to Admin Portal</p>
            <div class="mb-4">
              <label for="signin-email" class="form-label-lg">Email</label>
              <input type="email" v-model="email" class="form-control" id="signin-email" placeholder="Your email address" required>
            </div>
            <div class="mb-4 password-field">
              <label class="form-label-lg" for="signin-password">Password</label>
              <div class="password-toggle">
                <input class="form-control" v-model="password" type="password" id="signin-password">
                <label class="password-toggle-btn" aria-label="Show/hide password">
                  <input class="password-toggle-check" type="checkbox">
                  <span class="password-toggle-indicator"></span>
                </label>
              </div>
            </div>
            <div class="d-flex justify-content-between align-items-center mb-4">
              <a href="#" class="fs-sm text-decoration-none">Forgot password?</a>
            </div>
            <button type="submit" :disabled="loggingin" class="btn btn-outline-primary w-100">Sign in</button>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
  .card {
    box-shadow: 0 0 35px 0 rgba(154, 161, 171, .15);
  }
</style>